import { gsap } from "gsap";
import { SplitText } from "../plugins/gsap/SplitText";

gsap.registerPlugin(SplitText);

class TypewriterAnimation {
    constructor(elements) {
        this.elementTypewriter = elements;
        gsap.set(document.querySelectorAll('[data-typewriter]'), {alpha: 1});
        this.elementTypewriter.forEach((element, index) => {
            this.splitTextChar = new SplitText(element, {type: "chars",reduceWhiteSpace:false});
            this.chars = this.splitTextChar.chars;

            gsap.from(this.chars, {opacity: 0, duration: 1, stagger: 0.05,delay:1, ease: "expo.out"})
        });
    }
}

export default TypewriterAnimation;
